import { Injectable } from '@angular/core';
import {
  ErrorMessage,
  LoginAuthenticationScreen,
  LoginAuthUserInputFields
} from '@com-delta-idp/mnx-login-ui';
import { OauthAEMConfig } from '@com-delta-idp/mnx-oauth';
import { LoginModalContent } from '../login-modal/models/aem';
import { loginAndGetDashboardResponse } from '../login-modal/models/login-authentication-screen.interface';
import { LoginAuthenticationSupportService } from './login-authentication-support.service';

@Injectable({
  providedIn: 'root'
})
export class LoginAuthenticationHelperService extends LoginAuthenticationSupportService {
  disableBizLoginResponseCheck(
    response: loginAndGetDashboardResponse,
    corpCookie: string | null
  ): boolean | undefined {
    return response?.isBusiness && !response?.isSMEOnly && !corpCookie;
  }

  restrictLoginPickerIsHipmunkCheck(
    restrictLoginPicker: boolean,
    isHipmunk: string | false | null,
    fromAdmin: boolean
  ) {
    return restrictLoginPicker && !isHipmunk && !fromAdmin
      ? 'true-true'
      : 'true-false';
  }

  getErrorMessageFromAem(
    aemContent: LoginModalContent,
    errorCode: string | undefined
  ): string | undefined {
    const { errors } = aemContent;
    const errorDetails: ErrorMessage | undefined = errors.errorMessages.find(
      (element) => element.errorId === errorCode
    );
    return errorDetails?.errorMessageDescription;
  }

  validityCheckForFormSubmit(
    userInputFields: LoginAuthUserInputFields | undefined,
    authConfig: OauthAEMConfig
  ): boolean {
    return this.loginHelperUtils.isValidityCheckForFormSubmit(
      userInputFields,
      authConfig
    );
  }

  checkForAccessToken(tokenResponse: {
    errorId?: string;
    access_token?: string;
  }): boolean {
    let makeLoginAndDashboardCall = false;
    makeLoginAndDashboardCall =
      !tokenResponse?.errorId && tokenResponse?.access_token ? true : false;
    return makeLoginAndDashboardCall;
  }

  setLocalStorageForPersistentLogin(
    encryptedToken: string,
    uniqueIdentifier: string
  ): void {
    if (encryptedToken && uniqueIdentifier) {
      this.coreUtilService.set('encyToken', encryptedToken);
      this.coreUtilService.set('uid', uniqueIdentifier);
    }
  }

  setPromptCookie(
    userInputFields: LoginAuthUserInputFields | undefined,
    authenticationConfig: OauthAEMConfig
  ) {
    if (
      userInputFields?.persistentLogin === 'Y' &&
      authenticationConfig.PERSISTENT_COOKIE_TIMER
    ) {
      this.coreUtilService.setCookieName(
        'prompt',
        true,
        authenticationConfig.PERSISTENT_COOKIE_TIMER,
        false,
        authenticationConfig
      );
    }
  }

  checkForMakingBackendCall(
    flowIdForTheTransaction: string | undefined
  ): boolean {
    let makeCall = false;
    makeCall = flowIdForTheTransaction ? true : false;
    return makeCall;
  }

  checkForNotLoggedin(response: loginAndGetDashboardResponse): boolean {
    let makeStartSloCall = false;
    if (this.loginHelperUtils.loginIsFalse(response)) {
      makeStartSloCall = true;
    }
    return makeStartSloCall;
  }

  checkForExcludeList(
    excludeList: string | undefined,
    response: loginAndGetDashboardResponse
  ) {
    return (
      response?.errors && excludeList?.indexOf(response?.errors[0]?.code) !== -1
    );
  }

  getTransformedContent(
    transformedContent: LoginAuthenticationScreen,
    aemContent: LoginModalContent
  ) {
    return {
      ...transformedContent,
      errorCode: '',
      errorMessage: this.getErrorMessageFromAem(
        aemContent,
        transformedContent?.authenticationEnabled?.errorId
      )
    };
  }
}
